<template>
  <div>
    <Modal v-model="userForm" title="新增用户" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <Row>
            <Col span="24">
                <FormItem label="用户名" prop="username" :class="{requireStar:true}" >
                  <Input v-model="formValidate.username" :maxlength="16" ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <FormItem label="单位" prop="unit" :class="{requireStar:true}" >
                  <Input v-model="formValidate.unit"  ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="密码" prop="password" :class="{requireStar:true}">
                    <Input v-model="formValidate.password" type="password"  :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="确认密码" prop="password2" :class="{requireStar:true}">
                    <Input v-model="formValidate.password2" type="password"  :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row >
            <Col span="24">
                  <FormItem label="用户类型" prop="auth">
                    <RadioGroup v-model="formValidate.auth">
                      <Radio label="super" >超级管理员</Radio>
                      <Radio label="admin" >管理员</Radio>
                      <Radio label="handlers">操作者</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import md5 from 'js-md5';
  export default {
    components:{
    },
    data() {
         //自定义密码验证规则
         
          const validatePass =(rule, value, callback)=> {
              if (value === '') {
                  callback(new Error('请输入密码'));
              } else{
                 console
                if(this.formValidate.password!=this.formValidate.judpwd){
                      let reg =/^(?=.*[a-zA-Z])(?=.*[1-9])(?=.*[\W]).{6,16}$/;
                      if (!reg.test(value)) {
                       callback(new Error('密码必须由字母、数字、特殊符号中的3种类型组成,且长度为6~16位'));
                      }else{
                        callback();
                      }
                }else{
                   callback();
                }
                //let  reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$%\*-\+=:,\\?\[\]\{}]).{6,16}$/;
                
              }
          };
          const validatePassCheck = (rule, value, callback)=>{
              if (value === '') {
                   callback(new Error('请再次输入密码'));
              } else{
               // let reg = /^.{6,16}$/
                if(value !== this.formValidate.password){
                  return callback(new Error('两次密码不一致'));
                }else{
                  callback();
                }
              }
          };
      
      return {
        userForm: false,
       
      
        formValidate: {
          _id: '',
          username: '',
          password: '',
          password2: '',
          unit:'',
          auth:'',
         judpwd:''
        },
        ruleValidate: {
          username:  [
                {required: true,message: '用户名不能为空', trigger: 'change'},
                { pattern: /^.{6,16}$/, message: "用户名6~16位", trigger: "blur" }
            ],
          password:  [{validator: validatePass, trigger: 'blur' }],
          password2: [{validator: validatePassCheck, trigger: 'blur' }],
          unit: [{
            required: true,
            message: '单位名称不能为空',
            trigger: 'change'
          }],
           auth: [{
            required: true,
            message: '用户类型不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(title,row) {
        this.title =title
        this.userForm = true
        this.handleReset("formValidate");
        if(row!=null){
          this.formValidate=row
          this.formValidate.password2=row.password
          this.formValidate.judpwd=row.password
        }
      },
      
    
      
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url =  'api/user'
             let _password='';
            if(this.formValidate.password==this.formValidate.judpwd){
              _password=this.formValidate.password;
            }else{
                _password=md5(escape(this.formValidate.password).replace(/\+/g, '%2B').replace(/\"/g,'%22').replace(/\'/g, '%27').replace(/\//g,'%2F'))
            }
           
            let myData = {
              type:1,
              _id: this.formValidate._id,
              username: this.formValidate.username,
              password: _password,
              unit: this.formValidate.unit,
              auth: this.formValidate.auth,
            
              
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
         
              if (response.data.code == 200) {
                this.$Message.success(response.data.msg);
                this.$parent.loadPage();
              } else {
                 this.$Message.error(response.data.msg);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    
    },
   
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/user/UserEdit.vue